export const getUserData = () => {
  return {
    name: 'Max Mustermann',
    email: 'max.mustermann@example.com',
    profilePicture: '/Florian.png',
    plan: 'Premium',
    position: 'Software Engineer',
    company: 'Example Corp',
    phone: '+49 123 456789',
    address: 'Musterstraße 1, 12345 Musterstadt',
  };
}; 